module.exports = __webpack_public_path__ + "img/jpg.b3a56786.svg";